import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcVr(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.791 20.097c-.234.404-.056.925.39 1.063q1.276.395 2.586.433a9.6 9.6 0 0 0 3.347-.485 9.6 9.6 0 0 0 2.97-1.619 9.3 9.3 0 0 0 2.274-2.663q1.12-1.938 1.262-4.06.143-2.121-.67-4.205l.528.47a.702.702 0 1 0 .862-1.104l-2.499-1.703a.5.5 0 0 0-.74.214l-1.21 2.773a.69.69 0 1 0 1.302.45l.22-.849q.794 1.809.694 3.692a7.9 7.9 0 0 1-1.069 3.56q-1.499 2.595-4.291 3.57a7.92 7.92 0 0 1-5.009.107.816.816 0 0 0-.947.356m-4.608-2.283a.5.5 0 0 0 .723-.189l1.403-2.742a.733.733 0 1 0-1.328-.623l-.4.937q-.774-1.825-.682-3.704a7.8 7.8 0 0 1 1.06-3.557q1.5-2.596 4.292-3.568a7.92 7.92 0 0 1 5.007-.108c.362.109.76-.03.95-.357.233-.405.057-.925-.388-1.067q-2.949-.939-5.937.041Q5.475 3.996 3.64 7.174q-1.12 1.938-1.265 4.064t.668 4.21l-.766-.622a.717.717 0 1 0-.85 1.155z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.72 10.328v1.602h.84c.528 0 .84-.309.84-.797 0-.48-.332-.805-.844-.805zm0 2.582v1.473a.5.5 0 0 1-.5.5h-.433a.5.5 0 0 1-.5-.5V9.746a.5.5 0 0 1 .5-.5h1.914c1.406 0 2.164.695 2.164 1.86 0 .691-.348 1.324-.965 1.593l.752 1.454a.5.5 0 0 1-.444.73h-.477a.5.5 0 0 1-.448-.28l-.832-1.693zM10.437 14.535a.5.5 0 0 1-.476.348H8.887a.5.5 0 0 1-.477-.348L6.932 9.898a.5.5 0 0 1 .477-.652h.556a.5.5 0 0 1 .485.376l.99 3.859h.03l.986-3.859a.5.5 0 0 1 .485-.376h.498a.5.5 0 0 1 .476.652z"
  }));
}
var IcVr = createNolIcon(/*#__PURE__*/forwardRef(SvgIcVr));

export { IcVr as I };
